import { Component, ElementRef, EventEmitter, HostBinding, HostListener, Input, Output, ChangeDetectionStrategy } from '@angular/core';

import { Message, Room } from '@shared/factories';
import { ChatService, FormatDatesService, NotificationService } from '@shared/services';

@Component({
  selector:      'chats-list-item',
  templateUrl: './chats-list-item.component.html',
  host: { class: 'am-flex-align gap-xs pl-s pr-xs pt-xs pb-xs font-m hover-bg-white' },
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ChatsListItem {
  @Input() room:     Room;
  @Input() isActive: boolean;
  @Input() menuUp:   boolean;
  menuOpen:          boolean;

  @Output() openRoom  = new EventEmitter<void>();
  @Output() leaveRoom = new EventEmitter<void>();
  @HostBinding('class.bg-light-blue') get active() { return this.isActive; };

  @HostListener('document:click', ['$event'])
  outsideClick(event: Event): void {
    if (this.menuOpen && !this.eRef.nativeElement.contains(event.target)) this.menuOpen = false;
  }
  @HostListener('document:keydown.escape')
  escape(): void {
    this.menuOpen = false;
  }

  constructor(
    private eRef:                ElementRef,
    private chatService:         ChatService,
    private notificationService: NotificationService,
  ) { }

  getMessageTime(message: Message): string {
    return FormatDatesService.timeAgo(message?.createdAt);
  }

  get preview(): string {
    let message = this.room?.latestMessage;
    if (!message) return null;
    let prefix = message.bulkMessageId ? 'Gruppe: ' : message.participantId === this.room.meAsPartisipant?.id ? 'Du: ' : '';
    return prefix + message.text;
  }

  highlightRoom(): boolean {
    return this.room?.isParticipant || this.emptyRoomWithUnreadMessage();
  }

  emptyRoomWithUnreadMessage(): boolean {
    let empty  = this.room?.activeParticipants?.filter(p => !p.isOwner)?.length === 0;
    let unread = this.room?.activeMessages?.filter(m => !m.bulkMessageId).length;
    return empty && !!unread;
  }

  toggleMenu(): void {
    this.menuOpen = !this.menuOpen;
  }

  leaveHandler(): void {
    this.menuOpen = false;
    this.notificationService.confirm(
      'Warnung',
      'Bist du dir sicher, dass du gehen willst?',
      () => this.leave()
    );
  }

  private leave(): void {
    this.notificationService.wait();
    this.chatService.leaveRooom(this.room.id).subscribe(
      ()  => {
        this.notificationService.close();
        this.leaveRoom.emit();
      },
      err => this.notificationService.alert(err)
    );
  }

  readAll(): void {
    this.menuOpen = false;
    this.notificationService.wait();
    this.chatService.markAllAsRead(this.room.id).subscribe(
      () => this.notificationService.close(),
      err => this.notificationService.alert(err)
    );
  }

}